export default "__VITE_ASSET__DkD5krnb__"